
function photoHotSpot(data, no) {
	this.properties = data;
	this.helper = null;
	this.helperLeft = null;
	this.helperRight = null;
	this.clicks = 0;
	this.no = no;

	this.properties.x = parseInt(this.properties.x);
	this.properties.y = parseInt(this.properties.y);

	this.alpha = 100;
	this.alpha2 = 100;
	this.hovering = false;
	this.hoveringdt = 0;
	this.no_preview = false;

	//Log.debug(data.spot);
//	if (data.place.place_name == "") 
		var spotFile = "";
		var spotFileHover = "";
		var skip = false;
		var style = "";
		var style2 = "";
		var cls = "";
		var dim = [50,50];
		var hasPreview = (data.place.place_type != "autopilot" ? true : false);

		var tname = "hotspot-template";

		if (data.spot == "1") spotFile = "1";
		if (data.spot == "2") spotFile = "2";
		if (data.spot == "3") spotFile = "3";
		if (data.spot == "4") spotFile = "4";
		if (data.spot == "5") spotFile = "5";
		if (data.spot == "6") spotFile = "6";
		if (data.spot == "7") spotFile = "7";
		if (data.spot == "10") spotFile = "10";
		if (data.spot == "11") spotFile = "11";
		if (data.spot == "14") spotFile = "14";
		if (data.spot == "15") spotFile = "15";
		if (data.spot == "15") spotFile = "15";
		if (data.spot == "16") spotFile = "16";
		if (data.spot == "17") spotFile = "17";
		if (data.spot == "18") spotFile = "18";

		var addition = "";
		var start = false;

		if (data.spot == "hotspots/spot24.swf") {start = true; spotFile = "start24"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot23.swf") {start = true; spotFile = "start23"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot22.swf") {start = true; spotFile = "start22"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot21.swf") {start = true; spotFile = "start21"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot20.swf") {start = true; spotFile = "start20"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot19.swf") {start = true; spotFile = "start19"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot18.swf") {start = true; spotFile = "start18"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot17.swf") {start = true; spotFile = "start17"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot16.swf") {start = true; spotFile = "start16"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot15.swf") {start = true; spotFile = "start15"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot14.swf") {start = true; spotFile = "start14"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot13.swf") {start = true; spotFile = "start13"; tname = "hotspot-start-template"; dim = [172,172];}
		if (data.spot == "hotspots/spot12.swf") {start = true; spotFile = "start12"; tname = "hotspot-start-template"; dim = [172,172];}

		if (start) addition = "data-speakgroup='TIPS' data-speak='HTML5.tips.start'";

		this.idim = [dim[0], dim[1]];
		this.tname = tname;
		var smul = 1;

		if (data.xscale != undefined) {
			var sw = $(document).width();
			if (data.xscreen != undefined) {
				smul = sw / parseFloat(data.xscreen);
			}
			dim[0] = dim[0] * (parseFloat(data.xscale) * smul * 0.01);
		}

		if (data.yscale != undefined) {
			var sh = $(document).height();
			dim[1] = dim[1] * (parseFloat(data.yscale) * smul * 0.01);
		}

		style = 'left:' + (-dim[0] * 0.5) + "px;top:" + (-dim[1] * 0.5) + "px";
		style2 = 'left:' + (-dim[0] * 0.5) + "px;top:" + (-dim[1] * 0.5) + "px";

		fstyle = 'left:' + (-dim[0] * 0.5) + "px;top:" + (-dim[1] * 0.5) + "px;width:" + dim[0] + "px;height:" + dim[1] + "px";
		hstyle = "";

		if (data.param1 != undefined) {
			var rgba = data.param1.split(",");
			if (rgba.length >= 4) {
				var alpha = (255 + parseFloat(rgba[3])) / 255;
				style += ";opacity:" + alpha;
				this.alpha = parseInt(alpha * 100);
			}
			if (rgba.length >= 5) {
				var alpha2 = (255 + parseFloat(rgba[4])) / 255;
				hstyle += ";opacity:" + alpha2;
				this.alpha2 = parseInt(alpha2 * 100);
			}
		}

		if (data.no_preview === true || data.no_preview == "true" || data.no_preview == 1) this.no_preview = true;

		/*
		ponizszy kod pokazuje ikony z mapy zamiast punktow, jezeli ikona jest ustawiona na miejscu
		zakomentowane 05.03.2021
		if (data.mapicon != undefined &&  data.mapicon != "" && (data.nomapicon == undefined || data.nomapicon == false)) {
			skip = true;
			spotFile = "../../gicons/" + data.mapicon;
			spotFileHover = "../../gicons/" + data.mapicon;
			cls = " icon";
			dim[0] = 32; dim[1] = 37;
			style = "position:absolute;left:-16px;top:-32px";
			style2 = "position:absolute;left:-16px;top:-32px";
		}
		*/

		if (start && this.no_preview) cls += " primary";
		else if (start) cls += " speaks primary";

		data.fullName = data.place.place_name;
		if (data.fullName == "") data.fullName = "Zdjęcie " + data.ident;

		var ltitle = data.fullName;
		if (start) ltitle = TPL.lng("tips.starttour", "Rozpocznij zwiedzanie od: ") + data.fullName;

		if (start && this.no_preview) ltitle = "START";

		this.node = $("<div class='hotspot" + cls + "' title='" + ltitle + "' id='" + no + "' " + addition + " tabindex='0'></div>");
		this.node.css("outline", "none");

		if (spotFile == "") {
			spotFile = "/html5/assets/hotspot2_top.png";
		//	this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2_bg.png' width='50' height='50'><img src='/html5/assets/hotspot2_top.png' width='50' height='50' class='fulllooprotation'><div class='spotdesc'><a href='javascript:void(null);' ontouchend='player.go(" + data.ident + "," + data.angle + ")' class='button'>Przejdź</a></div></div>"); //HotSpotManager.more(\"" + no + "\")
		} else if (skip == false) {
//			spotFile = "hotspot2_top.png";
			spotFileHover = "/html5/assets/spots/hover_" + spotFile + ".png";
			spotFile = "/html5/assets/spots/" + spotFile + ".png";
		//	this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2_bg.png' width='50' height='50'><img src='/html5/assets/spots/" + spotFile + ".png' width='50' height='50'><img src='/html5/assets/hotspot2_top.png' width='50' height='50' class='fulllooprotation'><div class='spotdesc'><a href='javascript:void(null);' ontouchend='player.go('" + data.ident + "'," + data.angle + ")' class='button'>Przejdź</a></div></div>"); //HotSpotManager.more(\"" + no + "\")
		}

		if (player.offline) {
			spotFile = spotFile.replace("/html5/", "");
			spotFileHover = spotFileHover.replace("/html5/", "");;
		}

		//console.log(data);

		var thumbnail = data.place.thumb;
		if (player.offline) thumbnail = "data/thumb_" + data.ident + ".jpg";

		if (data.ident.substr(0,4) == "http") {
			hasPreview = false;
			data.fullName = data.ident;
			if (data.ident.length > 35) data.fullName = data.ident.substr(0,35) + " ...";
		}

		if (this.no_preview) {
			hasPreview = false;
		}

		this.node.html(TPL.render(tname, {"no": no, "hasPreview" : hasPreview, "spotfile": spotFile, "spotfileHover": spotFileHover, "ident": data.ident, "angle": data.angle, "click" : "on" + Events.pointer.down, "data": data, "thumbnail": thumbnail, "ico_width": dim[0], "ico_height": dim[1], "style": style, "style2": style2, "hstyle": hstyle, "fstyle": fstyle}));

		this.node.find(".marker").addClass("fin");

		var self = this;
		if (tname == "hotspot-start-template") {
			if (!player.cms) this.node.on(Events.pointer.up, function() { self.proceed();});
		} else {
			this.node.on("mouseover", function() { 
				self.target();
				if (!this.hovering && (Date.now() - this.hoveringdt) > 1000) self.speakTitle();
				this.hoveringdt = Date.now();
				this.hovering = true;
			});
			this.node.on("mouseout", function() { 
				self.noMore();
				this.hovering = false;
			});
			if (!player.cms) 
				this.node.on(Events.pointer.up, function() { self.proceed();});
		}

		this.node.find(".close").on(Events.pointer.up, function(e) {self.noMore(); e.stopPropagation();});
//	else
//		this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2.png' width='50' height='50' ontouchend='HotSpotManager.more(\"" + no + "\")'><div class='spotdesc'>" + data.place.place_name + "<br><br><a href='javascript:void(null);' ontouchend='player.go(" + data.ident + "," + data.angle + ")' class='button'>Przejdź</a></div></div>");
	
	this.no = no;
//	$("#player").append(this.node);

	Tab.add("hotspots", {
		"focus": function(m) {
			//console.log("focus szybka prezentacja");
//			m.node.children("img").addClass("focused");
			m.node.children(".rest").addClass("focused");
			m.node.focus();
		},

		"blur": function(m) {
			//console.log("blur szybka prezentacja");
			//m.node.children("img").removeClass("focused");
			m.node.children(".rest").removeClass("focused");
			m.node.blur();
		},

		"action": function(m) {
			m.proceed();
		}
	}, this, 0);

	if (player.cms) {
		if (this.editor == undefined) {
			this.editor = new HotSpotEdit(this);
			//this.no = no;
			//this.hasPreview = hasPreview;
			//this.thumbnail = thumbnail;

			//this.dim = dim;
			//this.style = style;
			this.editor.addUI();
		} else {
			var self = this;
		    this.node.on("click", function(evt) {var pe = Events.getPointerEvent(evt); self.editor.click(pe);});
		    //this.node.append(this.editor.mover);
		    this.editor.hs = this;
		    this.editor.hs.node = this.node;
		    
			this.editor.addUI();
		}
	}

	$("#hotspots").append(this.node);
}

photoHotSpot.prototype = {

	updateIcon: function(icon) {
		var start;
		var spotFile;
		var spotFileHover;
		var tname;
		var dim;
		var addition;

		var no = this.no;

		dim = [50, 50];
		tname = "hotspot-template";

		if (icon == "1") spotFile = "1";
		if (icon == "2") spotFile = "2";
		if (icon == "3") spotFile = "3";
		if (icon == "4") spotFile = "4";
		if (icon == "5") spotFile = "5";
		if (icon == "6") spotFile = "6";
		if (icon == "7") spotFile = "7";
		if (icon == "10") spotFile = "10";
		if (icon == "11") spotFile = "11";
		if (icon == "14") spotFile = "14";
		if (icon == "15") spotFile = "15";
		if (icon == "15") spotFile = "15";
		if (icon == "16") spotFile = "16";
		if (icon == "17") spotFile = "17";
		if (icon == "18") spotFile = "18";

		if (icon == "hotspots/spot24.swf") {start = true; spotFile = "start24"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot23.swf") {start = true; spotFile = "start23"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot22.swf") {start = true; spotFile = "start22"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot21.swf") {start = true; spotFile = "start21"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot20.swf") {start = true; spotFile = "start20"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot19.swf") {start = true; spotFile = "start19"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot18.swf") {start = true; spotFile = "start18"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot17.swf") {start = true; spotFile = "start17"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot16.swf") {start = true; spotFile = "start16"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot15.swf") {start = true; spotFile = "start15"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot14.swf") {start = true; spotFile = "start14"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot13.swf") {start = true; spotFile = "start13"; tname = "hotspot-start-template"; dim = [172,172];}
		if (icon == "hotspots/spot12.swf") {start = true; spotFile = "start12"; tname = "hotspot-start-template"; dim = [172,172];}

		this.idim = [dim[0], dim[1]];

		this.tname = tname;

		this.properties.spot = icon;

//		if (data.xscale != undefined) dim[0] = dim[0] * (parseFloat(data.xscale) * 0.01);
//		if (data.yscale != undefined) dim[1] = dim[1] * (parseFloat(data.yscale) * 0.01);

		var style = 'left:' + (-dim[0] * 0.5) + "px;top:" + (-dim[1] * 0.5) + "px";
		var style2 = 'left:' + (-dim[0] * 0.5) + "px;top:" + (-dim[1] * 0.5) + "px";
		var cls = "";

		if (start) cls += " speaks primary";

		if (spotFile == "") {
			spotFile = "hotspot2_top.png";
		} else {
			spotFileHover = "/html5/assets/spots/hover_" + spotFile + ".png";
			spotFile = "/html5/assets/spots/" + spotFile + ".png";
		}

		//console.log(data);

		var data = this.properties;
		var hasPreview = (data.place.place_type != "autopilot" ? true : false);

		data.fullName = data.place.place_name;
		if (data.fullName == "") data.fullName = "Zdjęcie " + data.ident;

		var thumbnail = data.place.thumb;
		if (player.offline) thumbnail = "data/thumb_" + data.ident + ".jpg";

		if (data.ident.substr(0,4) == "http") {
			hasPreview = false;
			data.fullName = data.ident;
			if (data.ident.length > 35) data.fullName = data.ident.substr(0,35) + " ...";
		}

		this.node.html(TPL.render(tname, {"no": no, "hasPreview" : hasPreview, "spotfile": spotFile, "spotfileHover": spotFileHover, "ident": data.ident, "angle": data.angle, "click" : "on" + Events.pointer.down, "data": data, "thumbnail": thumbnail, "ico_width": dim[0], "ico_height": dim[1], "style": style, "style2": style2}));

		this.node.find(".marker").addClass("fin");

		this.editor.addUI();

//	else
//		this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2.png' width='50' height='50' ontouchend='HotSpotManager.more(\"" + no + "\")'><div class='spotdesc'>" + data.place.place_name + "<br><br><a href='javascript:void(null);' ontouchend='player.go(" + data.ident + "," + data.angle + ")' class='button'>Przejdź</a></div></div>");

		/*
		this.node.find(".ico").attr("src", "/html5/assets/spots/" + spotFile + ".png");
		this.node.find(".ico_hover").attr("src", "/html5/assets/hover_" + spotFile + ".png");

		this.node.html(TPL.render(tname, {"no": no, "hasPreview" : hasPreview, "spotfile": spotFile, "spotfileHover": spotFileHover, "ident": data.ident, "angle": data.angle, "click" : "on" + Events.pointer.down, "data": data, "thumbnail": thumbnail, "ico_width": dim[0], "ico_height": dim[1], "style": style, "style2": style2}));

		this.node.find(".marker").addClass("fin");
		*/
	},

	setSpotParams: function(par) {
		var ic = this.node.find(".ico");
		var ich = this.node.find(".ico_hover");
		var hove = this.node.find(".hovering");

		if (par.scale != undefined) {
			dim = [this.idim[0], this.idim[1]];
			dim[0] = dim[0] * (parseFloat(par.scale) * 0.01);
			dim[1] = dim[1] * (parseFloat(par.scale) * 0.01);

			ic.css("left",-dim[0] * 0.5);
			ic.css("top",-dim[1] * 0.5);
			ic.attr("width", dim[0]);
			ic.attr("height", dim[1]);

			ich.css("left",-dim[0] * 0.5);
			ich.css("top",-dim[1] * 0.5);
			ich.attr("width", dim[0]);
			ich.attr("height", dim[1]);
		}
		if (par.opacity != undefined) {
			ic.css("opacity", parseInt(par.opacity) * 0.01);
		}
		if (par.opacity_hover != undefined) {
			hove.css("opacity", parseInt(par.opacity_hover) * 0.01);
		}
		/*
		if (data.param1 != undefined) {
			var rgba = data.param1.split(",");
			if (rgba.length >= 4) {
				var alpha = (255 + parseFloat(rgba[3])) / 255;
				style += ";opacity:" + alpha;
			}
		}
		*/
	},

	speakTitle: function() {		
		if (this.properties.place.speech_title != undefined && this.properties.place.speech_title != null && this.properties.place.speech_title != "") {
//			console.log("Speaks: " + this.properties.place.speech_title);
			SpeechManager.speakTip(this.properties.place.speech_title, "TOPMENU");
		}
	},

	setAction: function(id, angle, turn) {
		this.properties.ident = id;
		this.properties.angle = angle != undefined ? angle : 0;
		if (turn != undefined) this.properties.turn_to = turn;
	},

	more: function() {
		this.node.find(".spotdesc").show();
		//var all = $("#hotspots .hotspot");
		//this.node.insertBefore(all.eq(0));
		$("#hotspots").append(this.node);
	},
	
	noMore: function() {
		this.node.find(".spotdesc").hide();
	},

	getTurn: function(t, a) {

		var dirs = a.split(",");
		var turn = [];
		if (!isNaN(t)) t = t.toString();
		
		if (t != undefined && t != "") {
			turn = t.split(",");
			turn[0] = parseInt(turn[0]) + parseInt(dirs[0]);
			if (turn.length > 1) {
				turn[1] = parseInt(turn[1]);
				if (dirs.length > 1) turn[1] += parseInt(dirs[1]);
			}
		}
		

		var res = turn[0];
		if (turn.length > 1) res += "," + turn[1];

		return res;
		
		//return t;
	},

	proceed: function() {
		var self = this;

		var a = self.properties.angle;

		//if (player.cms) alert(self.properties.turn_to);

		if (self.properties.turn_to != undefined) {
			var tt = self.getTurn(self.properties.turn_to, self.properties.angle);
			a = [self.properties.angle, tt];
		}

		player.go(self.properties.ident, a);
	},

	target: function() {
		var self = this;
		
		HotSpotManager2D.more(self.no);
		/*
		setTimeout(function() {
			if (self.clicks < 2) {
				HotSpotManager2D.more(self.no);
				self.clicks = 0;
			}
		}, 300);
		*/

		/*
		this.clicks ++;
		if (this.clicks > 1) this.noMore();
		*/
	},

	process: function(x, y, w, h) {
		this.node.show();
		
//		var nx = x + this.properties.x * w / 1000;
//		var ny = y + this.properties.y * h / 500;

		var nx = x + (this.properties.x / 1000) * w;
		var ny = y + (this.properties.y / 500) * h;

		this.node.css("left", nx + "px");
		this.node.css("top", ny + "px");
	},
	
	remove: function() {
		this.node.remove();
	},

}